module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dawn-attention-box-wrapper"
  }, [_c('div', {
    staticClass: "title-area"
  }, [_c('h1', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.subtitle) ? _c('p', {
    staticClass: "page-subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _c('div', {
    staticClass: "dawn-attention-box"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc6164e8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edBox/index.vue
// module id = wUbH
// module chunks = 13 14